import { render, staticRenderFns } from "./integralReturnList.vue?vue&type=template&id=6309b14e&scoped=true"
import script from "./integralReturnList.vue?vue&type=script&lang=js"
export * from "./integralReturnList.vue?vue&type=script&lang=js"
import style0 from "./integralReturnList.vue?vue&type=style&index=0&id=6309b14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309b14e",
  null
  
)

export default component.exports